/**
 * @description: 艺人主管轮台报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ytc-report">
        <div class="yzl-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-date">
                    <div ref="yzlTime">
                        <input type="text" class="form-control laydate-icon" v-model="yzlStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="yzlEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="yzlShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">消费包厢:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择消费包厢" ref="yzlBox"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢区域" ref="yzl_area"></select>
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="yzl_tit_sel">
                        <option value="0">全部</option>
                        <option value="1">员工</option>
                        <option value="2">艺人</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="yzl_con_val" :placeholder="yzl_con_phd">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="yzl_group_txt" ref="yzl_group_txt" readonly disabled @click="yzlEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" placeholder="请输入姓名" v-model="yzl_charger" ref="yzl_charger" disabled>
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <input type="text" class="form-control" placeholder="请输入姓名" v-model="yzl_admin">
                </div>
            </div>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYzlTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYzlExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="yzlList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="yzlExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='yzlExport_allcheck' @click='yzlExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="room_area_name">
                            <label>区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="create_time">
                            <label>操作时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="stand_admin_name">
                            <label>轮台人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="stand_admin_role">
                            <label>职务</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="personnel_group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='yzlExport_checkModel' value="set_admin_name">
                            <label>操作人</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='yzlExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='yzlExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="yzl-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="yzl_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYzlGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='yzl_group_allcheck' @click='groupYzlCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in yzl_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='yzl_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="yzlGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="yzlGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                yzlStartTime: "",
                yzlEndTime: "",
                yzl_field: "0",
                yzl_con_phd: "请输入姓名",
                yzl_con_val: "",
                yzl_group_txt: "",
                yzl_group_allcheck: false,
                yzl_c_group_allcheck: false,
                yzl_group_checkboxModel: [],
                c_yzl_group_checkboxModel: [],
                yzl_group_checkboxData: [],
                yzl_group_name: '',
                yzl_charger: '',
                yzl_admin: '',
                yzlExport_allcheck: false,
                c_yzlExport_allcheck: false,
                yzlExport_checkModel: [],
                yzlExport_checkData: ['shop_name', 'room_area_name', 'room_name', 'create_time', 'stand_admin_name', 'stand_admin_role', 'personnel_group_name', 'set_admin_name'],
                yzlExport_type: 1,
                yzl_total: '',
            }
        },
        watch: {
            yzl_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.yzl_group_checkboxModel.length >= this.yzl_group_checkboxData.length) {
                        this.yzl_group_allcheck = true;
                        this.yzl_c_group_allcheck = true;
                    } else {
                        this.yzl_group_allcheck = false;
                        this.yzl_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            yzlExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.yzlExport_checkModel.length >= this.yzlExport_checkData.length) {
                        this.yzlExport_allcheck = true;
                        this.c_yzlExport_allcheck = true;
                    } else {
                        this.yzlExport_allcheck = false;
                        this.c_yzlExport_allcheck = false;
                    }
                },
                deep: true
            }
        },
        mounted: function() {
            const _this = this
            _this.yzlStartTime = moment().format('YYYY-MM-DD');
            _this.yzlEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput(); // 门店
            // 下拉选项
            $(_this.$refs.yzl_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.yzl_field = $(this).val();
                _this.yzl_con_val = '';
                // 组别
                _this.yzl_group_txt = '';
                _this.yzl_group_checkboxModel = [];
                $(_this.$refs.yzl_group_txt).prop("disabled", false);
                // 主管
                _this.yzl_charger = '';
                $(_this.$refs.yzl_charger).prop('disabled', false);
                if(_this.yzl_field == '0') {
                    _this.yzl_con_phd = '请输入姓名';
                    $(_this.$refs.yzl_group_txt).prop("disabled", true);
                    $(_this.$refs.yzl_charger).prop('disabled', true);
                } else if(_this.yzl_field == '1') {
                    _this.yzl_con_phd = '请输入员工姓名';
                    $(_this.$refs.yzl_charger).prop('disabled', true);
                } else if(_this.yzl_field == '2') {
                    _this.yzl_con_phd = '请输入艺人昵称';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.yzlStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                            this.yzlEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                        }else {
                            this.yzlStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                            this.yzlEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function(num) {
                let _this = this;
                $(_this.$refs.yzlTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.yzlStartTime = start.format('YYYY-MM-DD');
                    _this.yzlEndTime = end.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function(num) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.yzlShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.yzl_group_checkboxModel = [];
                                _this.yzl_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    // 包厢号
                                    $(_this.$refs.yzlBox).val('').trigger('change');
                                    $(_this.$refs.yzlBox).prop('disabled', false);
                                    // 区域
                                    $(_this.$refs.yzl_area).val('').trigger('change');
                                    $(_this.$refs.yzl_area).prop('disabled', false);
                                    return;
                                }
                                // 包厢号
                                $(_this.$refs.yzlBox).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                // 区域
                                $(_this.$refs.yzl_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.yzlShop).val(data.response.result[1].id).trigger('change');
                            // 包厢号
                            $(_this.$refs.yzlBox).prop('disabled', false);
                            _this.getRoomdata(data.response.result[1].id);
                            // 区域
                            $(_this.$refs.yzl_area).prop('disabled', false);
                            _this.getRoomArea(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitYzlTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: ' ', text: '全部'}];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.yzl_area).html("");
                            $(_this.$refs.yzl_area).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.yzlBox).html("");
                            $(_this.$refs.yzlBox).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



            // 进入选择组别
            yzlEnterGroup: function() {
                this.c_yzl_group_checkboxModel = this.yzl_group_checkboxModel;
                this.yzl_group_checkboxModel = [];
                this.getYzlGroupData();
                this.yzl_group_checkboxModel = this.c_yzl_group_checkboxModel;
                $('.yzl-list').hide();
                $('.yzl-group').show();
            },
            // 获取组别列表
            getYzlGroupData: function() {
                let _this = this;

                let key_word = '';
                if(_this.yzl_field == '1') {
                    key_word = 'user';
                } else if(_this.yzl_field == '2') {
                    key_word = 'personnel';
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.yzlShop).val(),
                            "key_word": key_word,
                            "group_name": _this.yzl_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.yzl_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYzlCheckedAll: function() {
                let _this = this;
                _this.yzl_group_allcheck = _this.yzl_c_group_allcheck;
                if(!_this.yzl_group_allcheck) { // 实现全选
                    _this.yzl_group_checkboxModel = [];
                    _this.yzl_group_checkboxData.forEach(function(item) {
                        _this.yzl_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.yzl_group_checkboxModel = [];
                }
            },
            // 返回
            yzlGroupBack: function() {
                $('.yzl-group').hide();
                $('.yzl-list').show();
                this.yzl_group_checkboxModel = this.c_yzl_group_checkboxModel;
            },
            yzlGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.yzl_group_checkboxData.forEach(function(item) {
                    _this.yzl_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.yzl_group_txt = arr.join(',');
                $('.yzl-group').hide();
                $('.yzl-list').show();
            },
            // 表格
            innitYzlTable: function() {
                let _this = this;
                $(_this.$refs.yzlList).bootstrapTable('destroy');
                $(_this.$refs.yzlList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYzlList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "11%"
                    }, {
                        field: "room_area_name",
                        title: "区域",
                        width: "11%"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "11%"
                    }, {
                        field: "create_time",
                        title: "操作时间",
                        width: "11%"
                    }, {
                        field: "stand_admin_name",
                        title: "轮台人",
                        width: "11%"
                    }, {
                        field: "stand_admin_role",
                        title: "职务",
                        width: "11%"
                    }, {
                        field: "personnel_group_name",
                        title: "组别",
                        width: "11%"
                    }, {
                        field: "set_admin_name",
                        title: "操作人",
                        width: "11%"
                    }],
                });
            },
            // 数据
            getYzlList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.yzlStartTime,
                            "end_date": _this.yzlEndTime,
                            "shop_id": $(_this.$refs.yzlShop).val(),
                            "room_id": $.trim($(_this.$refs.yzlBox).val()),
                            "room_area": $.trim($(_this.$refs.yzl_area).val()),
                            "stand_admin_type": _this.yzl_field,
                            "stand_admin_name": _this.yzl_con_val,
                            "personnel_director_name": _this.yzl_charger,
                            "group_id": _this.yzl_group_checkboxModel,
                            "set_admin_name": _this.yzl_admin
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/standLog",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == '1') {
                                _this.yzl_total = data.response.total;
                            }
                            params.success({
                                total: _this.yzl_total,
                                rows: data.response.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYzlExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/standLogExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.yzlExport_checkModel = data.response.result.export_fields;
                                _this.yzlExport_type = data.response.result.export_type;
                            } else {
                                _this.yzlExport_checkModel = _this.yzlExport_checkData;
                                _this.yzlExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.yzlExport_alert)
                }, function() {
                    _this.exportYzlList();
                });
            },
            // 导出字段全选
            yzlExportCheckedAll: function() {
                let _this = this;
                _this.yzlExport_allcheck = _this.c_yzlExport_allcheck;
                if(!_this.yzlExport_allcheck) { // 实现全选
                    _this.yzlExport_checkModel = [];
                    _this.yzlExport_checkData.forEach(function(item) {
                        _this.yzlExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.yzlExport_checkModel = [];
                }
            },
            // 导出
            exportYzlList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.yzlExport_checkModel);

                window.location.href = Vue.ctUrl + "FinanceReport2/standLogExport?" +
                    "start_date=" + _this.yzlStartTime +
                    "&end_date=" + _this.yzlEndTime +
                    "&shop_id=" + $(_this.$refs.yzlShop).val() +
                    "&room_id=" + $.trim($(_this.$refs.yzlBox).val()) +
                    "&room_area=" + $.trim($(_this.$refs.yzl_area).val()) +
                    "&stand_admin_type=" + _this.yzl_field +
                    "&stand_admin_name=" + _this.yzl_con_val +
                    "&personnel_director_name=" + _this.yzl_charger +
                    "&group_id=" + _this.yzl_group_checkboxModel +
                    "&set_admin_name=" + _this.yzl_admin +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.yzlExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .yzl-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>